import { actions as primaryCategoryMappingActions } from 'modules/api/product/primaryCategoryMappingModule';
import { put } from 'redux-saga/effects';

export default function* primaryCategoryMappingSagas() {
	yield put(primaryCategoryMappingActions.init());
}
